import apiClient from './client';

export const MBCB_NOTIFICATION_EVENT_REPORT_SUBMITTED = 'mbcb_report_submitted';

export interface MbcbNotificationSettingDto {
  id?: number;
  eventType: string;
  enabled: boolean;
  includeAssignedHubLeader: boolean;
  includeRoles: string[];
  additionalUserIds: number[];
  additionalEmails: string[];
  persisted: boolean;
  createdAt?: string | null;
  updatedAt?: string | null;
}

export interface MbcbNotificationUpdatePayload {
  enabled?: boolean;
  includeAssignedHubLeader?: boolean;
  includeRoles?: string[];
  additionalUserIds?: number[];
  additionalEmails?: string[];
}

export interface NotificationUserSearchResult {
  id: number;
  firstName: string;
  lastName: string;
  email: string;
  roles: string[];
}

export async function getMbcbNotificationSetting(
  eventType: string
): Promise<MbcbNotificationSettingDto> {
  const res = await apiClient.get(`/admin/mbcb-notification-settings/${eventType}`);
  return res.data.data;
}

export async function updateMbcbNotificationSetting(
  eventType: string,
  payload: MbcbNotificationUpdatePayload
): Promise<MbcbNotificationSettingDto> {
  const res = await apiClient.put(`/admin/mbcb-notification-settings/${eventType}`, payload);
  return res.data.data;
}

export async function previewMbcbNotificationRecipients(
  eventType: string,
  body: { planterId?: number | null; draft?: MbcbNotificationUpdatePayload }
): Promise<{
  recipients: string[];
  effective: MbcbNotificationUpdatePayload & { enabled: boolean };
}> {
  const res = await apiClient.post(`/admin/mbcb-notification-settings/${eventType}/preview`, body);
  return res.data.data;
}

export async function searchUsersForNotifications(
  search: string,
  limit = 30
): Promise<NotificationUserSearchResult[]> {
  const res = await apiClient.get('/admin/mbcb-notification-settings/user-search', {
    params: { search, limit },
  });
  return res.data.data;
}
